import { Box } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import oneDark from 'react-syntax-highlighter/dist/esm/styles/prism/one-dark';
import oneLight from 'react-syntax-highlighter/dist/esm/styles/prism/one-light';
import { CopyTextButton } from '@backstage/core-components';

/** Syntax-highlighted GraphQL snippet using Prism (hljs doesn't support GraphQL). */
export function GraphQLSnippet({ text }: { text: string }) {
  const theme = useTheme();
  const style = theme.palette.type === 'dark' ? oneDark : oneLight;

  return (
    <Box position="relative">
      <SyntaxHighlighter
        language="graphql"
        style={style}
        showLineNumbers
        wrapLines
      >
        {text}
      </SyntaxHighlighter>
      <Box position="absolute" top={0} right={0}>
        <CopyTextButton text={text} />
      </Box>
    </Box>
  );
}
